const FOCUSABLE_ELEMENT_SELECTORS =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';

const KEY_CODE_MAP = {
  TAB: 9,
};

/**
 * @param parentEl: jQuery Element. The Parent element, within which the focus should be trapped
 * @param $cleanupFocusEl: jQuery Element to focus on after cleanup
 * @param $initialFocusEl: <Optional> jQuery Element. If not provided, focus is put to the first focusable element
 * @return {Function} Cleans up keyboard event and returns focus to cleanupFocusEl
 */
export default ($parentEl, $cleanupFocusEl, $initialFocusEl = null) => {
  if (!$parentEl) {
    console.error('No parent element found');
    return;
  }

  const focusableElements = $parentEl.find(FOCUSABLE_ELEMENT_SELECTORS);

  if (focusableElements.length > 0) {
    const firstFocusableEl = focusableElements[0];
    const lastFocusableEl = focusableElements[focusableElements.length - 1];
    const elementToFocus = $initialFocusEl ? $initialFocusEl : firstFocusableEl;
    elementToFocus.focus();

    $parentEl.on('keydown.focusTrap', evt => {
      if (evt.keyCode === KEY_CODE_MAP.TAB) {
        if (evt.shiftKey && document.activeElement === firstFocusableEl) {
          evt.preventDefault();
          lastFocusableEl.focus();
        } else if (!evt.shiftKey && document.activeElement === lastFocusableEl) {
          evt.preventDefault();
          firstFocusableEl.focus();
        }
      }
    });
  }

  return () => {
    $cleanupFocusEl.focus();
    $parentEl.off('keydown.focusTrap');
  };
};
